// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');    

	dropWrappers.forEach((item) => {
		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove("active");
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = "0";
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains("active") ? `${content.scrollHeight}px` : "0";
			}
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	handleDropdown();
});